import { useCallback } from "react";
import {
  DailyInsightType,
  InsightsRequestType,
  ModalityInsightType,
} from "../types/generalTypes";
import { getCourtInsights, getModalityInsights } from "../api/InsightsAPI";

interface useInsightsProps {
  setInsights: React.Dispatch<React.SetStateAction<DailyInsightType[]>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface useModalityInsightsProps {
  setModalityInsights: React.Dispatch<
    React.SetStateAction<ModalityInsightType[]>
  >;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useInsights = ({
  setInsights,
  setIsLoading,
}: useInsightsProps) => {
  const fetchInsights = useCallback(
    async (request: InsightsRequestType) => {
      try {
        setIsLoading(true);
        const insightsData = await getCourtInsights(request);
        setInsights(insightsData);
      } catch (error) {
        console.error("Failed to fetch insights:", error);
        setInsights([]);
      } finally {
        setIsLoading(false);
      }
    },
    [setInsights, setIsLoading],
  );

  return { fetchInsights };
};

export const useModalityInsights = ({
  setModalityInsights,
  setIsLoading,
}: useModalityInsightsProps) => {
  const fetchModalityInsights = useCallback(
    async (request: InsightsRequestType) => {
      try {
        setIsLoading(true);
        const insightsData = await getModalityInsights(request);
        setModalityInsights(insightsData);
      } catch (error) {
        console.error("Failed to fetch modality insights:", error);
        setModalityInsights([]);
      } finally {
        setIsLoading(false);
      }
    },
    [setModalityInsights, setIsLoading],
  );

  return { fetchModalityInsights };
};
